import {
  DATE_RANGE_PRESET_DAYS,
  DATE_RANGE_PRESET_MONTHS,
  DATE_RANGE_PRESETS,
} from '../Consts/date-range-presets.const';
import { DateRangeBounds } from '../Interfaces/date-range-bounds.interface';
import { DateRangePresetOption } from '../Interfaces/date-range-preset-option.interface';
import { DateRangePresetId } from '../Types/date-range-preset-id.type';

function startOfDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function daysBefore(day: Date, days: number): Date {
  return new Date(day.getFullYear(), day.getMonth(), day.getDate() - days);
}

function monthsBefore(day: Date, months: number): Date {
  const target = new Date(day.getFullYear(), day.getMonth() - months, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  return new Date(target.getFullYear(), target.getMonth(), Math.min(day.getDate(), lastDay) + 1);
}

function resolveStart(id: DateRangePresetId, today: Date, floor: Date): Date {
  switch (id) {
    case 'maximum':
      return floor;
    case 'last12Months':
    case 'last3Months':
      return monthsBefore(today, DATE_RANGE_PRESET_MONTHS[id]);
    case 'last30Days':
    case 'last7Days':
      return daysBefore(today, DATE_RANGE_PRESET_DAYS[id] - 1);
    case 'thisMonth':
      return new Date(today.getFullYear(), today.getMonth(), 1);
  }
}

function clamp(day: Date, floor: Date, ceiling: Date): Date {
  if (day.getTime() < floor.getTime()) return floor;
  return day.getTime() > ceiling.getTime() ? ceiling : day;
}

export function buildDateRangePresetOptions(bounds: DateRangeBounds): DateRangePresetOption[] {
  const today = startOfDay(bounds.max);
  const floor = startOfDay(bounds.min);

  return DATE_RANGE_PRESETS.map((preset) => ({
    ...preset,
    from: clamp(resolveStart(preset.id, today, floor), floor, today),
    to: today,
  }));
}
